import * as types from './types';
import AppVersionService from '../../services/AppVersionService';

export const setAppVersion = version => ({
    type: types.APP_VERSION_CHANGED,
    payload: version,
});

export const fetchAppVersion = () => async dispatch => {
    try {
        const response = await AppVersionService.getAppVersion();

        const { info, item } = response;

        if (!info.success) {
            return;
        }

        const { version } = item;

        dispatch(setAppVersion(version));
    } catch (error) {
        console.error(error);
    }
};

export const changeDeviceStatus = payload => ({
    type: types.DEVICE_STATUS_CHANGED,
    payload,
});
